import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createShipmentIconButtonTooltip: {
    defaultMessage: 'Create another shipment based on current shipment selection',
    description: 'Tooltip for the create shipment icon button',
    id: '/B2OlG',
  },
  restrictedByMarketplaceCreateShipmentIconButtonTooltip: {
    defaultMessage: '{marketplaceName} does not allow you to create another shipment',
    description: 'Tooltip for the create shipment icon button when disabled',
    id: 'zfGPVP',
  },
});
